<template>
  <section class="hero formhero">
      <div class="hero__content container">
        <div class="hero__content--info">
          <h1 class="hero__title">
              <b>Sign Up for the</b><br>
              Sequire Investor<br> 
              Summit: Puerto Rico
          </h1>
          <p class="hero__description">
            Join us at Sequire-in-Paradise, a premium destination conference for speakers and investors held at the La Concha Resort in San Juan, Puerto Rico.
          </p>
          <p class="hero__description">
            Learn about 40+ presentations from public companies, discussions with business leaders, and keynote speakers covering the newest developments in investment. 
          </p>
          <p class="hero__description">
            Profit from Puerto Rico's investor-friendly tax rules while taking advantage of networking opportunities on the beach, nightly entertainment, and delectable Caribbean cuisine.
          </p>
          <p class="hero__description">
            Don't pass up this priceless in-person opportunity.
          </p>
        </div>
        <div class="formhero__form">
          <presenterform />
        </div>
      </div>
  </section>
  </template>
  
  <script>
  import presenterform from '@/components/presenterform.vue';

  export default {
    name: 'FormHero',
    components: {
      presenterform
    },
    data () {
      return {
      }
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
    @import "../styles/components/hero.scss";

    .formhero__form div::v-deep {
      .form__fields {
        h1 {
          font-weight: 600;
          margin-bottom: 20px;
        }
        h1, p {
          color: #fff;
        }
      }
      #subscribe-result {
        .text {
          color: #fff;
          h1, p {
            color: #fff;
          }
        }
      }
    }
      
  </style>
  